import { render, staticRenderFns } from "./MiraSplitBars.vue?vue&type=template&id=b338d710&scoped=true&"
import script from "./MiraSplitBars.vue?vue&type=script&lang=ts&"
export * from "./MiraSplitBars.vue?vue&type=script&lang=ts&"
import style0 from "./MiraSplitBars.vue?vue&type=style&index=0&id=b338d710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b338d710",
  null
  
)

export default component.exports